'use client';

import { PageContainer, withRouteGuard } from '@capsicum/common-web';
import { CredentialGuardLoader } from '@capsicum/features/regulations/web';
import { SurveyDetails, useSurveyGuard } from '@capsicum/features/survey/web';

const Page = ({ params }: { params: { partnerId: string; surveyId: string } }) => (
	<PageContainer body={<SurveyDetails {...params} />} variant="background-view" />
);

export default withRouteGuard(Page, [useSurveyGuard], CredentialGuardLoader);
